import LeadForm from './LeadForm';
import PageMeta from './PageMeta';
import TelStoreCover from './TelStoreCover';
import { RedesignFooter, RedesignHeader, RedesignPage } from './RedesignShell';

const solutionBlocks = [
  {
    title: 'Разработка сайта с нуля',
    intro: 'Создан интернет-магазин техники с продуманной структурой:',
    points: [
      'каталог товаров с фильтрами',
      'индивидуальная дизайн-система',
      'карточки товаров с SEO-контентом',
      'корзина и оформление заказа',
      'личный кабинет',
      'адаптивная мобильная версия',
      'интеграция с Telegram-ботом',
    ],
    note: 'Сайт сразу проектировался под поведение пользователей и конверсию.',
  },
  {
    title: 'Разработка собственной CMS',
    intro: 'Вместо шаблонных решений разработана индивидуальная CMS. Это позволило:',
    points: [
      'гибко управлять каталогом товаров',
      'быстро вносить изменения',
      'масштабировать проект без ограничений',
      'интегрировать нужные сервисы',
    ],
    note: 'Клиент получил систему управления, полностью адаптированную под бизнес.',
  },
  {
    title: 'SEO-оптимизация сайта',
    intro: 'SEO выполнялось на этапе разработки сайта:',
    points: [
      'сбор семантического ядра',
      'формирование структуры сайта',
      'оптимизация страниц и мета-тегов',
      'настройка технической части',
      'оптимизация смарт-фильтров',
    ],
    note: 'Это позволило начать получать трафик сразу после запуска.',
  },
  {
    title: 'Запуск и продвижение',
    intro: 'После запуска сайта началась работа с трафиком:',
    points: ['SEO-продвижение', 'настройка аналитики', 'запуск рекламы в Яндекс.Директ'],
    note: 'Подключение рекламы дало быстрый поток заявок уже в первый месяц.',
  },
];

const resultCards = [
  {
    title: 'SEO и органический трафик',
    points: [
      'рост позиций в поисковых системах',
      'увеличение органического трафика на 40% за 3 месяца',
      'выход в ТОП по коммерческим запросам',
    ],
  },
  {
    title: 'Контекстная реклама',
    points: ['средняя цена клика — 125 рублей', 'стабильный поток целевых пользователей'],
  },
  {
    title: 'Конверсии и продажи',
    points: ['стоимость одного заказа — 1500 рублей', 'сайт стал основным каналом привлечения клиентов'],
  },
];

function TechStoreCasePage() {
  return (
    <RedesignPage>
      {/* TODO(brand-redesign): получить утверждённые Title и Description; текущие provisional-значения не подтверждены исходным ТЗ. */}
      <PageMeta
        title="Создание интернет-магазина техники в Москве | Кейс Fatality"
        description="Кейс Fatality: разработка интернет-магазина техники под ключ, собственная CMS, SEO-оптимизация и запуск рекламы. Рост органического трафика на 40% за 3 месяца."
      />
      <RedesignHeader />

      <section className="ink case-detail-hero">
        <div
          className="glow"
          style={{ right: '-340px', top: '-320px', width: '940px', height: '940px', opacity: 0.1 }}
        />
        <div className="container">
          <h1>Создание интернет-магазина техники в Москве</h1>
          <p className="hero-sub">
            Разработка интернет-магазина техники под ключ для рынка Москва.
          </p>
          <p className="hero-sub">
            Проект включал полный цикл: от создания сайта с нуля до SEO-продвижения и запуска рекламы.
          </p>
          <p className="service-hero-copy">
            Результат: рост органического трафика на 40% за 3 месяца и стабильные продажи через сайт.
          </p>
          <TelStoreCover alt="Кейс TelStore — интернет-магазин, CRM и CMS" />
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container case-two-col">
          <div>
            <h2 className="standalone-h2">Задача проекта</h2>
          </div>
          <div className="case-rich-text">
            <p>Клиент обратился за разработкой интернет-магазина техники с нуля.</p>
            <p>Основные задачи:</p>
            <ul>
              <li>создать современный интернет-магазин под ключ</li>
              <li>разработать собственную CMS под бизнес-процессы</li>
              <li>подготовить сайт под SEO-продвижение</li>
              <li>запустить рекламу и получать заявки</li>
            </ul>
            <p>
              Важно: нужен был не просто сайт, а инструмент продаж с
              возможностью масштабирования.
            </p>
          </div>
        </div>
      </section>

      <section className="ink sec-pad">
        <div className="container">
          <div className="sec-head ink-head">
            <div>
              <h2>Решение</h2>
            </div>
            <p className="sub">
              Проект реализован с учетом задач бизнеса и особенностей ниши
              электроники.
            </p>
          </div>
          <div className="solution-grid">
            {solutionBlocks.map((block) => (
              <article className="solution-card" key={block.title}>
                <h3>{block.title}</h3>
                <p>{block.intro}</p>
                <ul>
                  {block.points.map((point) => (
                    <li key={point}>{point}</li>
                  ))}
                </ul>
                <p>{block.note}</p>
              </article>
            ))}
          </div>
          <a href="/images/cases/telstore-cms.webp" aria-label="Открыть изображение админки TelStore в полном размере">
            <img
              className="case-cover-image"
              src="/images/cases/telstore-cms.webp"
              alt="Админка TelStore, раздел управления категориями каталога"
              width="1672"
              height="941"
              loading="lazy"
              decoding="async"
            />
          </a>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <div className="sec-head">
            <div>
              <h2>Результаты проекта</h2>
            </div>
            <p className="sub">
              Проект показал рост по ключевым бизнес-показателям.
            </p>
          </div>
          <div className="result-grid">
            {resultCards.map((result) => (
              <div className="compact-card" key={result.title}>
                <h3>{result.title}</h3>
                <ul className="source-list">
                  {result.points.map((point) => (
                    <li key={point}>{point}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <p className="service-hero-copy" style={{ color: '#141619' }}>
            В результате интернет-магазин начал приносить прибыль уже на раннем этапе.
          </p>
        </div>
      </section>

      <section className="ink sec-pad">
        <div className="container case-two-col">
          <div>
            <h2 className="standalone-h2 light">Что получил клиент</h2>
          </div>
          <div className="case-rich-text dark">
            <p>
              В рамках проекта клиент получил не просто разработку сайта, а готовую систему продаж:
            </p>
            <ul>
              <li>интернет-магазин техники под ключ</li>
              <li>индивидуальную CMS</li>
              <li>SEO-оптимизированный сайт</li>
              <li>настроенную рекламу</li>
              <li>поток заявок и заказов</li>
            </ul>
            <p>Сайт стал основным инструментом привлечения клиентов и роста бизнеса.</p>
          </div>
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container case-two-col">
          <div>
            <h2 className="standalone-h2">Почему этот кейс важен</h2>
          </div>
          <div className="case-rich-text">
            <p>Этот проект показывает, что разработка интернет-магазина — это не только дизайн и программирование.</p>
            <p>Ключевой фактор — комплексный подход:</p>
            <ul>
              <li>разработка</li>
              <li>SEO</li>
              <li>маркетинг</li>
              <li>аналитика</li>
            </ul>
            <p>Только в таком формате сайт начинает реально работать и приносить результат.</p>
          </div>
        </div>
      </section>

      <section className="ink lead" id="case-lead">
        <div
          className="glow"
          style={{ left: '-300px', top: '-200px', width: '700px', height: '700px', opacity: 0.1 }}
        />
        <div className="container" style={{ position: 'relative' }}>
          <div className="lead-grid">
            <div className="lead-side">
              <h2 className="lead-heading">Хотите такой же результат?</h2>
              <p className="lead-text">
                Разработка интернет-магазина под ключ — это инвестиция в рост бизнеса.
              </p>
              <p className="lead-text">
                Оставьте заявку — разберем ваш проект, покажем точки роста и рассчитаем стоимость разработки сайта.
              </p>
            </div>
            <LeadForm
              formId="case-lead-form"
              idPrefix="case"
              eyebrow="Форма заявки"
            />
          </div>
        </div>
      </section>

      <RedesignFooter />
    </RedesignPage>
  );
}

export default TechStoreCasePage;
